import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';

export interface Props {}

const StudioProductsCatalogCardA: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId="9cf590fc-df94-4528-9a00-2810d2cddaaf"
  />
);
StudioProductsCatalogCardA.displayName = 'StudioProductsCatalogCardA';

export default StudioProductsCatalogCardA;
